import { BookingStatus, type BookingStatusType } from "src/store/slices/hotels/Hotels";

type BookingStatusBadge = {
  label: string;
  className: string;
};

export const BOOKING_STATUS_BADGES: Record<BookingStatusType, BookingStatusBadge> = {
  [BookingStatus.Pending]: { label: "BookingResult.summary.status.pending", className: "bg-background-warning text-font-warning" },
  [BookingStatus.Confirmed]: { label: "BookingResult.summary.status.confirmed", className: "bg-background-success text-font-success" },
  [BookingStatus.Failed]: { label: "BookingResult.summary.status.failed", className: "bg-background-danger text-font-danger" },
};

const RATING_WORDS: Record<string, number> = { one: 1, two: 2, three: 3, four: 4, five: 5 };

// rating comes as "FourStar", "FiveStar", ...
export const parseStarRating = (rating: string | null) => {
  const word = rating?.match(/^(one|two|three|four|five)/i)?.[1]?.toLowerCase();
  return word ? RATING_WORDS[word] : 0;
};
